/**
 *    Datepicker congress calculator
 */

import moment from 'moment';
import 'daterangepicker';

(function ($) {
  Drupal.behaviors.datepickerCongressCalculator = {
    attach(context, settings) {
      const $datepickerPlaceholder = $('.vb-connected-inline-datepicker__text--placeholder');
      const $datepickerInput = $('[id*="vb-connected-inline-datepicker__input--"]');

      let locale = {};

      if (document.documentElement.lang === 'de') {
        locale = {
          daysOfWeek: [
            'So',
            'Mo',
            'Di',
            'Mi',
            'Do',
            'Fr',
            'Sa',
          ],
          monthNames: [
            'Januar',
            'Februar',
            'März',
            'April',
            'Mai',
            'Juni',
            'Juli',
            'August',
            'September',
            'Oktober',
            'November',
            'Dezember',
          ],
          firstDay: 1,
        };
      }

      // datepicker
      var $datepicker = $datepickerInput.daterangepicker({
        autoApply: true,
        parentEl: '#daterangepicker-container',
        showCustomRangeLabel: false,
        ranges: false,
        locale,
        alwaysShowCalendars: true,
        startDate: new Date().toLocaleDateString('en-US'), // '01/01/2021',
        minDate: '02/01/2024',
        maxDate: '12/31/2025',
        // startDate: moment(),
        // endDate: '01/06/2020',
      }, (start, end) => {
        // output dates
        if (start.format('DD.MM.YYYY') === end.format('DD.MM.YYYY')) {
          $datepickerPlaceholder.html(start.format('DD.MM.YYYY'));
        } else {
          $datepickerPlaceholder.html(`${start.format('DD.MM.YYYY')} bis ${end.format('DD.MM.YYYY')}`);
        }

        // output days
        const days = Math.abs(start.diff(end, 'days')) + 1;
        $datepickerInput.attr('data-days', days);

        setTimeout(() => {
          // show datepicker again
          $datepicker.data('daterangepicker').show();
        }, 0);
      });

      // show picker on load
      $datepicker.data('daterangepicker').show();

      const $triggerButton = $('.vb-connected-inline-datepicker__button:not(.vb-active)');
      const $container = $('.vb-connected-inline-datepicker');

      // show datepicker 'container'
      $triggerButton.on('click', () => {
        $container.toggleClass('vb-active');
        $datepicker.data('daterangepicker').show();
      });

      // on hide
      $datepicker.on('hide.daterangepicker', (event, picker) => {
        // fix auto close
        if ($datepickerInput.closest('.vb-filter-item--dropdown').hasClass('vb-open')) {
          // show datepicker again
          setTimeout(() => {
            // show datepicker again
            $datepicker.data('daterangepicker').show();
          }, 0);
        }
      });

      // click outside to close the options
      $(document).on('mouseup', (event) => {
        // trigger button click
        if ($(event.target).hasClass('vb-connected-inline-datepicker__text--placeholder')) {
          return false;
        }

        // container
        if (
          !$container.is(event.target) // if the target of the click isn't the container...
          && $container.has(event.target).length === 0 // ... nor a descendant of the container
        ) {
          $container.removeClass('vb-active');
          $datepicker.data('daterangepicker').show();
        }
      });
    },
  };
}(jQuery, Drupal));

// end of datepicker-congress-calculator.js
